<div class="thp-form-container">
  <div class="thp-form">
    <label class="thp-header">{{"talent-happy-path.talent-profile.preferences.title" | translate}}</label>

  <div class="field-group">
    <label class="field-label">{{"talent-happy-path.talent-profile.preferences.type" | translate}}</label>
    <mat-chip-listbox multiple>
        <mat-chip-option [selected]="form.get('contractSelected')?.value"
                  (click)="toggleSelection('contractSelected')"
                  [class]="form.get('contractSelected')?.value ? 'selected-chip' : ''"
                  selectable>
          {{"talent-happy-path.talent-profile.preferences.types.temp" | translate}}
        </mat-chip-option>
        <mat-chip-option [selected]="form.get('contractToHireSelected')?.value"
                  (click)="toggleSelection('contractToHireSelected')"
                         [class]="form.get('contractToHireSelected')?.value ? 'selected-chip' : ''"
                  selectable>
          {{"talent-happy-path.talent-profile.preferences.types.temp-to-perm" | translate}}
        </mat-chip-option>
        <mat-chip-option [selected]="form.get('permanentSelected')?.value"
                  (click)="toggleSelection('permanentSelected')"
                         [class]="form.get('permanentSelected')?.value ? 'selected-chip' : ''"
                  selectable>
          {{"talent-happy-path.talent-profile.preferences.types.perm" | translate}}
        </mat-chip-option>
    </mat-chip-listbox>
  </div>

  <div class="field-group">
    <label class="field-label">{{"talent-happy-path.talent-profile.preferences.work-hours" | translate}}</label>
    <mat-chip-listbox multiple>
        <mat-chip-option [selected]="form.get('fullTimeSelected')?.value"
                  (click)="toggleSelection('fullTimeSelected')"
                  [class]="form.get('fullTimeSelected')?.value ? 'selected-chip' : ''"
                  selectable>
          {{"talent-happy-path.talent-profile.preferences.types.full-time" | translate}}
        </mat-chip-option>
        <mat-chip-option [selected]="form.get('partTimeSelected')?.value"
                  (click)="toggleSelection('partTimeSelected')"
                  [class]="form.get('partTimeSelected')?.value ? 'selected-chip' : ''"
                  selectable>
          {{"talent-happy-path.talent-profile.preferences.types.part-time" | translate}}
        </mat-chip-option>
      </mat-chip-listbox>
  </div>

  <div class="field-group">
    <label class="field-label">{{"talent-happy-path.talent-profile.preferences.workplace" | translate}}</label>
    <mat-chip-listbox multiple>
        <mat-chip-option [selected]="form.get('onSiteSelected')?.value"
                  (click)="toggleSelection('onSiteSelected')"
                  [class]="form.get('onSiteSelected')?.value ? 'selected-chip' : ''"
                  selectable>
          {{"talent-happy-path.talent-profile.preferences.types.onsite" | translate}}
        </mat-chip-option>
        <mat-chip-option [selected]="form.get('hybridSelected')?.value"
                  (click)="toggleSelection('hybridSelected')"
                  [class]="form.get('hybridSelected')?.value ? 'selected-chip' : ''"
                  selectable>
          {{"talent-happy-path.talent-profile.preferences.types.hybrid" | translate}}
        </mat-chip-option>
        <mat-chip-option [selected]="form.get('offSiteSelected')?.value"
                  (click)="toggleSelection('offSiteSelected')"
                  [class]="form.get('offSiteSelected')?.value ? 'selected-chip' : ''"
                  selectable>
          {{"talent-happy-path.talent-profile.preferences.types.remote" | translate}}
        </mat-chip-option>
    </mat-chip-listbox>
  </div>
  </div>
  <div class="navigation-buttons">
    <button mat-stroked-button class="back-btn" (click)="goToEmploymentOpportunities()"><mat-icon>arrow_back</mat-icon> {{"talent-happy-path.buttons.back" | translate}}</button>
    <button mat-flat-button class="next-btn" (click)="goToEmploymentSalary()"><mat-icon>arrow_forward</mat-icon>{{"talent-happy-path.buttons.next" | translate}}</button>
  </div>
  <div class="button-container">
    <button mat-button class="later-button" (click)="isModalVisible = true" *ngIf="!fromNotAFit">{{"talent-happy-path.buttons.do-later" | translate}}</button>
    <app-confirmation-modal
      [isVisible]="isModalVisible"
      (isVisibleChange)="isModalVisible = $event"
      header="{{'talent-happy-path.talent-profile.later-modal.header' | translate}}"
      description="{{'talent-happy-path.talent-profile.later-modal.description' | translate}}"
      (cancel)="isModalVisible = false"
      (confirm)="doThisLater(); isModalVisible = false">
    </app-confirmation-modal>
  </div>
</div>
